import StudentsNotebook from '../../api/students_notebook';
const studentsNotebook = new StudentsNotebook();

const studentsNotebookModule = {
    namespaced: true,
    state: {
        loading: false,
        studentsNotebooks: [],
        studentNotebook: null,
        totalStudentsNotebooks: 0,
        studentsNotebookLookups: [],
    },
    getters: {
        studentsNotebooks: (state) => state.studentsNotebooks,
        studentNotebook: (state) => state.studentNotebook,
        totalStudentsNotebooks: (state) => state.totalStudentsNotebooks,
        studentsNotebookLookups: (state) => state.studentsNotebookLookups,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_STUDENTS_NOTEBOOKS: (state, data) => {
            state.studentsNotebooks = data;
        },
        SET_STUDENT_NOTEBOOK: (state, data) => {
            state.studentNotebook = data;
        },
        SET_TOTAL_STUDENTS_NOTEBOOKS: (state, count) => {
            state.totalStudentsNotebooks = count;
        },
        SET_STUDENTS_NOTEBOOK_LOOKUPS: (state, data) => {
            state.studentsNotebooksLookups = data;
        },
        UPDATE_NOTEBOOK_ITEM: (state, updatedItem) => {
            if (!updatedItem || !updatedItem.id) return;
            const index = state.studentsNotebooks.findIndex(item => String(item.id) === String(updatedItem.id));
            if (index !== -1) {
                state.studentsNotebooks.splice(index, 1, {
                    ...state.studentsNotebooks[index],
                    ...updatedItem
                });
            }
        },
    },
    actions: {
        GetStudentsNotebookLookups({ commit }, params) {
            return new Promise((resolve, reject) => {
                studentsNotebook.lookups(params).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.studentsNotebooks || response.students_notebooks || response.data || []);
                        commit('SET_STUDENTS_NOTEBOOK_LOOKUPS', data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GetStudentsNotebooks({ commit }, payload) {
            const query = (payload && payload.query) || {};
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                studentsNotebook.list(query).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.studentsNotebooks || response.students_notebooks || response.data || []);
                        commit('SET_STUDENTS_NOTEBOOKS', data);
                        commit('SET_TOTAL_STUDENTS_NOTEBOOKS', response.total || response.count || data.length || 0);
                    }

                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateStudentsNotebook({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                studentsNotebook.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteStudentsNotebook({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                studentsNotebook.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateStudentsNotebook({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                studentsNotebook.update(payload.id, payload.form).then(response => {
                    commit('SET_LOADING', false);
                    if (payload && payload.id && payload.form) {
                        commit('UPDATE_NOTEBOOK_ITEM', { id: payload.id, ...payload.form });
                    }
                    if (response && (response.studentNotebook || response.studentsNotebook || response.data)) {
                        const updated = response.studentNotebook || response.studentsNotebook || response.data;
                        commit('UPDATE_NOTEBOOK_ITEM', updated);
                    }
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        ShowStudentsNotebook({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                studentsNotebook.show(id).then(response => {
                    if (response) {
                        commit('SET_STUDENT_NOTEBOOK', response.studentNotebook || response.studentsNotebook || response.data || response);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default studentsNotebookModule;
